// Generated by tools/composition/build-flow-review.mjs. Edit the evidence bundle first.
import type { DurationCue } from '../types';
export const FLOW_REVIEW_SHA256 = 'b4ea488d3c840aa85390557b8f4d1a6ee9fc2bc8be497e36d2a4a54d41d9bf24';
export const SHORT_PAUSE_SEC = 120;
export const LONG_LINKS: Readonly<Record<string, readonly (readonly [number, number, number, number])[]>> = {
  "Friday Night Guided Meditation | Ajahn Brahmavamso | 01-12-2017 - 2017-12-04": [
    [
      0,
      480.62,
      636.18,
      155.56
    ]
  ],
  "Friday Night Guided Meditation | Ajahn Brahmavamso | 08-12-2017 - 2017-12-11": [
    [
      2,
      711.2,
      882.98,
      171.78
    ]
  ],
  "Friday Night Guided Meditation | Ajahn Brahmavamso | 1 June 2007 - 2019-04-25": [
    [
      3,
      704.22,
      923.08,
      218.86
    ]
  ],
  "Friday Night Guided Meditation | Ajahn Brahmavamso | 10 February 2017 - 2019-01-15": [
    [
      0,
      287.48,
      446.94,
      159.46
    ],
    [
      1,
      860.92,
      1005.04,
      144.12
    ]
  ],
  "Friday Night Guided Meditation | Ajahn Brahmavamso | 10 November 2006 - 2019-02-12": [
    [
      1,
      215.06,
      355.34,
      140.28
    ]
  ],
  "Friday Night Guided Meditation | Ajahn Brahmavamso | 11 December 2015 - 2018-12-26": [
    [
      0,
      288.88,
      428.36,
      139.48
    ],
    [
      1,
      518.08,
      654.04,
      135.96
    ]
  ],
  "Friday Night Guided Meditation | Ajahn Brahmavamso | 12 October 2007 - 2019-05-23": [
    [
      2,
      634.82,
      763.92,
      129.1
    ]
  ],
  "Friday Night Guided Meditation | Ajahn Brahmavamso | 20-10-2017 - 2017-10-23": [
    [
      4,
      495.46,
      618.22,
      122.76
    ]
  ],
  "Friday Night Guided Meditation | Ajahn Brahmavamso | 26 May 2017 - 2018-12-19": [
    [
      2,
      424.72,
      553.7,
      128.98
    ]
  ],
  "Friday Night Guided Meditation | Ajahn Brahmavamso | 27 April 2007 - 2019-04-12": [
    [
      1,
      275.26,
      514.88,
      239.62
    ]
  ],
  "Friday Night Guided Meditation | Ajahn Brahmavamso | 30 October 2009 - 2019-06-05": [
    [
      1,
      194.56,
      348.54,
      153.98
    ]
  ],
  "Friday Night Guided Meditation | Ajahn Brahmavamso | 5 January 2007 - 2019-03-07": [
    [
      1,
      263.48,
      390.86,
      127.38
    ]
  ],
  "Friday Night Guided Meditation | Ajahn Brahmavamso | 6 May 2016 - 2019-01-02": [
    [
      1,
      588.56,
      745.96,
      157.4
    ]
  ],
  "Friday Night Guided Meditation | Ajahn Brahmavamso | 8 March 2019 - 2019-03-11": [
    [
      1,
      244.68,
      371.82,
      127.14
    ]
  ],
  "Guided Meditation | Ajahn Brahmavamso | 01-01-2011 - 2018-08-16": [
    [
      0,
      486.98,
      671.28,
      184.3
    ],
    [
      1,
      707.12,
      941.22,
      234.1
    ]
  ],
  "Guided Meditation | Ajahn Brahmavamso | 01-02-2014 - 2018-07-28": [
    [
      0,
      1388.44,
      1525.36,
      136.92
    ]
  ],
  "Guided Meditation | Ajahn Brahmavamso | 01-06-2013 - 2018-08-29": [
    [
      0,
      1556.68,
      1816.08,
      259.4
    ]
  ],
  "Guided Meditation | Ajahn Brahmavamso | 01-11-2014 - 2018-10-13": [
    [
      2,
      1373.8,
      1601.38,
      227.58
    ]
  ],
  "Guided Meditation | Ajahn Brahmavamso | 01-12-2012 - 2018-10-05": [
    [
      0,
      1353.22,
      1742.34,
      389.12
    ]
  ],
  "Guided Meditation | Ajahn Brahmavamso | 02-06-2007 - 2018-08-18": [
    [
      1,
      1078.18,
      1263.4,
      185.22
    ],
    [
      7,
      3471.24,
      3599.46,
      128.22
    ]
  ],
  "Guided Meditation | Ajahn Brahmavamso | 02-07-2012 - 2018-10-01": [
    [
      1,
      1006.16,
      1128.64,
      122.48
    ]
  ],
  "Guided Meditation | Ajahn Brahmavamso | 03-01-2015 - 2018-10-04": [
    [
      3,
      967.52,
      1143.2,
      175.68
    ]
  ],
  "Guided Meditation | Ajahn Brahmavamso | 05-03-2014 - 2018-07-25": [
    [
      2,
      898.22,
      1048.12,
      149.9
    ]
  ],
  "Guided Meditation | Ajahn Brahmavamso | 05-05-2012 - 2018-09-25": [
    [
      1,
      747.26,
      977.6,
      230.34
    ]
  ],
  "Guided Meditation | Ajahn Brahmavamso | 05-12-2009 - 2018-09-04": [
    [
      0,
      691.1,
      922.7,
      231.6
    ]
  ],
  "Guided Meditation | Ajahn Brahmavamso | 06-01-2007 - 2018-07-29": [
    [
      0,
      1057.98,
      1274.42,
      216.44
    ]
  ],
  "Guided Meditation | Ajahn Brahmavamso | 06-02-2016 - 2018-08-18": [
    [
      2,
      1456.98,
      1681.9,
      224.92
    ]
  ],
  "Guided Meditation | Ajahn Brahmavamso | 07-02-2015 - 2018-09-28": [
    [
      0,
      1064.34,
      1207.76,
      143.42
    ],
    [
      1,
      1441.22,
      1579.96,
      138.74
    ]
  ],
  "Guided Meditation | Ajahn Brahmavamso | 07-05-2016 - 2018-08-06": [
    [
      0,
      404.86,
      527.66,
      122.8
    ]
  ],
  "Guided Meditation | Ajahn Brahmavamso | 08-04-17 - 2017-04-09": [
    [
      5,
      1831.74,
      2059.98,
      228.24
    ]
  ],
  "Guided Meditation | Ajahn Brahmavamso | 08-12-2012 - 2018-10-06": [
    [
      2,
      1402.78,
      1780.7,
      377.92
    ]
  ],
  "Guided Meditation | Ajahn Brahmavamso | 10-01-2015 - 2018-10-03": [
    [
      3,
      1024.14,
      1172.12,
      147.98
    ]
  ],
  "Guided Meditation | Ajahn Brahmavamso | 12-05-2007 - 2018-08-15": [
    [
      0,
      1146.34,
      1309.12,
      162.78
    ]
  ],
  "Guided Meditation | Ajahn Brahmavamso | 13-03-2010 - 2018-08-20": [
    [
      1,
      1334.94,
      1565.48,
      230.54
    ]
  ],
  "Guided Meditation | Ajahn Brahmavamso | 13-04-2013 - 2018-08-31": [
    [
      0,
      835.32,
      972.02,
      136.7
    ]
  ],
  "Guided Meditation | Ajahn Brahmavamso | 14-12-2013 - 2018-08-04": [
    [
      0,
      1391.82,
      1536.22,
      144.4
    ]
  ],
  "Guided Meditation | Ajahn Brahmavamso | 15-11-2014 - 2018-10-11": [
    [
      2,
      1154.72,
      1414.3,
      259.58
    ]
  ],
  "Guided Meditation | Ajahn Brahmavamso | 16-04-2016 - 2018-08-09": [
    [
      2,
      1400.64,
      1642.5,
      241.86
    ]
  ],
  "Guided Meditation | Ajahn Brahmavamso | 16-06-2007 - 2018-08-21": [
    [
      1,
      1197.58,
      1366.96,
      169.38
    ]
  ],
  "Guided Meditation | Ajahn Brahmavamso | 16-07-2016 - 2018-07-29": [
    [
      0,
      1531.9,
      1664.76,
      132.86
    ]
  ],
  "Guided Meditation | Ajahn Brahmavamso | 16-11-2013 - 2018-08-08": [
    [
      0,
      1107.4,
      1250.02,
      142.62
    ]
  ],
  "Guided Meditation | Ajahn Brahmavamso | 17-02-2007 - 2018-08-05": [
    [
      0,
      622.72,
      763.16,
      140.44
    ]
  ],
  "Guided Meditation | Ajahn Brahmavamso | 17-05-2014 - 2018-10-23": [
    [
      2,
      1548.8,
      1744.92,
      196.12
    ]
  ],
  "Guided Meditation | Ajahn Brahmavamso | 18-03-17 - 2017-03-18": [
    [
      1,
      1195.04,
      1336.58,
      141.54
    ]
  ],
  "Guided Meditation | Ajahn Brahmavamso | 18-04-2015 - 2018-09-16": [
    [
      1,
      908.48,
      1057.96,
      149.48
    ]
  ],
  "Guided Meditation | Ajahn Brahmavamso | 18-06-2016 - 2018-08-01": [
    [
      1,
      1388.56,
      1533.98,
      145.42
    ]
  ],
  "Guided Meditation | Ajahn Brahmavamso | 19-05-2012 - 2018-09-26": [
    [
      0,
      1230.78,
      1373.16,
      142.38
    ]
  ],
  "Guided Meditation | Ajahn Brahmavamso | 20-07-2013 - 2018-08-10": [
    [
      0,
      643.6,
      851.4,
      207.8
    ],
    [
      1,
      993.68,
      1180.24,
      186.56
    ]
  ],
  "Guided Meditation | Ajahn Brahmavamso | 21-03-2015 - 2018-09-21": [
    [
      1,
      1211.66,
      1356.16,
      144.5
    ],
    [
      2,
      1435.38,
      1568.16,
      132.78
    ]
  ],
  "Guided Meditation | Ajahn Brahmavamso | 21-04-2012 - 2018-09-22": [
    [
      0,
      991.56,
      1261.7,
      270.14
    ]
  ],
  "Guided Meditation | Ajahn Brahmavamso | 21-05-2016 - 2018-08-04": [
    [
      0,
      907.3,
      1121.64,
      214.34
    ],
    [
      3,
      1504.24,
      1897.32,
      393.08
    ]
  ],
  "Guided Meditation | Ajahn Brahmavamso | 21-11-2015 - 2018-08-28": [
    [
      0,
      1482.12,
      1709.96,
      227.84
    ]
  ],
  "Guided Meditation | Ajahn Brahmavamso | 26-11-2016 - 2016-11-27": [
    [
      0,
      1845.1,
      2070.92,
      225.82
    ]
  ],
  "Guided Meditation | Ajahn Brahmavamso | 27-11-2010 - 2018-08-22": [
    [
      0,
      695.46,
      898.46,
      203
    ]
  ],
  "Guided Meditation | Ajahn Brahmavamso | 28-04-2007 - 2018-08-14": [
    [
      2,
      1092.94,
      1285.54,
      192.6
    ]
  ],
  "Guided Meditation | Ajahn Brahmavamso | 28-07-2007 - 2018-08-30": [
    [
      1,
      1074.86,
      1200.8,
      125.94
    ]
  ],
  "Guided Meditation | Ajahn Brahmavamso | 30-04-2016 - 2018-08-07": [
    [
      1,
      1101.46,
      1234.54,
      133.08
    ]
  ],
  "Guided Meditation | Ajahn Brahmavamso | 30-06-2018 - 2018-07-03": [
    [
      0,
      1100.52,
      1225.52,
      125
    ],
    [
      2,
      1468.5,
      1690.68,
      222.18
    ]
  ],
  "Guided Meditation | Ajahn Brahmavamso | 31-01-2015 - 2018-09-29": [
    [
      1,
      1113.36,
      1285.18,
      171.82
    ]
  ],
  "Guided Meditation | Ajahn Brahmavamso | 9 March 2019 - 2019-03-12": [
    [
      0,
      1324.78,
      1498.66,
      173.88
    ]
  ]
};
export interface CueReview {
  cue: DurationCue;
  action: 'ignore' | 'retain' | 'existing-cut';
  band?: readonly [number, number];
}
export const CUE_REVIEWS: Readonly<Record<string, readonly CueReview[]>> = {
  "Friday Night Guided Meditation | Ajahn Brahmavamso | 02-12-2005 - 2017-08-12": [
    {
      "cue": {
        "island": 0,
        "atSec": 5.87,
        "endSec": 11.31,
        "text": "but now we're going to do a nice quiet time for 30 minutes.",
        "statedSec": 1800,
        "precision": "round",
        "bandMinSec": 1440,
        "bandMaxSec": 2430
      },
      "action": "retain"
    }
  ],
  "Friday Night Guided Meditation | Ajahn Brahmavamso | 08-12-2017 - 2017-12-11": [
    {
      "cue": {
        "island": 0,
        "atSec": 329.9,
        "endSec": 338.33,
        "text": "relaxed, comfortable, but strong. the sort of comfort which you can maintain for about 30 minutes.",
        "statedSec": 1800,
        "precision": "round",
        "bandMinSec": 1440,
        "bandMaxSec": 2430
      },
      "action": "retain"
    }
  ],
  "Friday Night Guided Meditation | Ajahn Brahmavamso | 09-12-2005 - 2017-08-05": [
    {
      "cue": {
        "island": 0,
        "atSec": 79.02,
        "endSec": 87.75,
        "text": "whatever position you find is comfortable, sufficient to maintain bodily stillness for 30 minutes, that is your posture.",
        "statedSec": 1800,
        "precision": "round",
        "bandMinSec": 1440,
        "bandMaxSec": 2430
      },
      "action": "retain"
    }
  ],
  "Friday Night Guided Meditation | Ajahn Brahmavamso | 1 March 2019 - 2019-03-04": [
    {
      "cue": {
        "island": 0,
        "atSec": 26.98,
        "endSec": 42.48,
        "text": "so anyway, now we can just, instead of talk about the world, we can leave the world for half an hour by having a nice quiet meditation.",
        "statedSec": 1800,
        "precision": "round",
        "bandMinSec": 1440,
        "bandMaxSec": 2430
      },
      "action": "retain"
    }
  ],
  "Friday Night Guided Meditation | Ajahn Brahmavamso | 11 December 2015 - 2018-12-26": [
    {
      "cue": {
        "island": 0,
        "atSec": 21.47,
        "endSec": 45.15,
        "text": "and now is the opportunity for meditating for half an hour, which is a wonderful opportunity just to be peaceful instead of telling people how to be happy, let's do it so closing grace, being aware of",
        "statedSec": 1800,
        "precision": "round",
        "bandMinSec": 1440,
        "bandMaxSec": 2430
      },
      "action": "retain"
    }
  ],
  "Friday Night Guided Meditation | Ajahn Brahmavamso | 11 January 2019 - 2019-01-14": [
    {
      "cue": {
        "island": 0,
        "atSec": 5.76,
        "endSec": 10.64,
        "text": "it start a wonderful thing to do for about 25 minutes.",
        "statedSec": 1500,
        "precision": "round",
        "bandMinSec": 1200,
        "bandMaxSec": 2025
      },
      "action": "retain"
    }
  ],
  "Friday Night Guided Meditation | Ajahn Brahmavamso | 12-01-2018 - 2018-01-15": [
    {
      "cue": {
        "island": 0,
        "atSec": 0,
        "endSec": 17.01,
        "text": "so now anyway we do a little bit of meditation. so if you get yourselves in a, i usually just give a guided meditation about 20 minutes and then afterwards just five or 10 minutes by yourselves and th",
        "statedSec": 1200,
        "precision": "round",
        "bandMinSec": 960,
        "bandMaxSec": 1620
      },
      "action": "retain",
      "band": [
        1440,
        2430
      ]
    }
  ],
  "Friday Night Guided Meditation | Ajahn Brahmavamso | 13 April 2007 - 2019-04-05": [
    {
      "cue": {
        "island": 0,
        "atSec": 206.1,
        "endSec": 211.5,
        "text": "now you're going to grant it 29 minutes of peace.",
        "statedSec": 1740,
        "precision": "round",
        "bandMinSec": 1392,
        "bandMaxSec": 2349
      },
      "action": "retain"
    }
  ],
  "Friday Night Guided Meditation | Ajahn Brahmavamso | 15 February 2019 - 2019-02-18": [
    {
      "cue": {
        "island": 0,
        "atSec": 951.73,
        "endSec": 956.87,
        "text": "have a little sleep, brain, for half an hour.",
        "statedSec": 1800,
        "precision": "round",
        "bandMinSec": 1440,
        "bandMaxSec": 2430
      },
      "action": "retain"
    }
  ],
  "Friday Night Guided Meditation | Ajahn Brahmavamso | 15-12-2017 - 2017-12-18": [
    {
      "cue": {
        "island": 0,
        "atSec": 107.08,
        "endSec": 117.23,
        "text": "be kind. and then check your bottom. your butt has to take a lot of pressure sitting still for half an hour.",
        "statedSec": 1800,
        "precision": "round",
        "bandMinSec": 1440,
        "bandMaxSec": 2430
      },
      "action": "retain"
    }
  ],
  "Friday Night Guided Meditation | Ajahn Brahmavamso | 16 February 2007 - 2019-03-22": [
    {
      "cue": {
        "island": 0,
        "atSec": 130.06,
        "endSec": 147.32,
        "text": "because you're can have to sit still for 30 minutes and if you don't look after your body in the beginning, it will complain in the middle and even scream by the end.",
        "statedSec": 1800,
        "precision": "round",
        "bandMinSec": 1440,
        "bandMaxSec": 2430
      },
      "action": "retain"
    }
  ],
  "Friday Night Guided Meditation | Ajahn Brahmavamso | 18 May 2007 - 2019-04-19": [
    {
      "cue": {
        "island": 0,
        "atSec": 0,
        "endSec": 8.65,
        "text": "very good, so again, welcome to the buddhist center. now we can begin the event today with some meditation for 30 minutes.",
        "statedSec": 1800,
        "precision": "round",
        "bandMinSec": 1440,
        "bandMaxSec": 2430
      },
      "action": "retain"
    }
  ],
  "Friday Night Guided Meditation | Ajahn Brahmavamso | 19 January 2007 - 2019-03-13": [
    {
      "cue": {
        "island": 0,
        "atSec": 0,
        "endSec": 5.92,
        "text": "so usually start the friday evening with a peaceful 30 minutes of meditation.",
        "statedSec": 1800,
        "precision": "round",
        "bandMinSec": 1440,
        "bandMaxSec": 2430
      },
      "action": "retain"
    }
  ],
  "Friday Night Guided Meditation | Ajahn Brahmavamso | 2 March 2007 - 2019-03-27": [
    {
      "cue": {
        "island": 0,
        "atSec": 19.89,
        "endSec": 26.64,
        "text": "very good. so because we're going to be sitting meditation for 30 minutes, it's nice to be quiet.",
        "statedSec": 1800,
        "precision": "round",
        "bandMinSec": 1440,
        "bandMaxSec": 2430
      },
      "action": "retain"
    }
  ],
  "Friday Night Guided Meditation | Ajahn Brahmavamso | 20 May 2016 - 2019-02-28": [
    {
      "cue": {
        "island": 0,
        "atSec": 159.93,
        "endSec": 179.53,
        "text": "so i don't think, i feel and i'm feeling the sensations in my body and my upper back, especially the shoulders, i relax them until i find that best posture, the sort of comfort which i can maintain fo",
        "statedSec": 1800,
        "precision": "round",
        "bandMinSec": 1440,
        "bandMaxSec": 2430
      },
      "action": "retain"
    }
  ],
  "Friday Night Guided Meditation | Ajahn Brahmavamso | 23-02-2018 - 2018-02-26": [
    {
      "cue": {
        "island": 0,
        "atSec": 69.99,
        "endSec": 93.89,
        "text": "if you move them, can they become more comfortable because sometimes people they complain after 10, 15 minutes they've got achy or pain there or their leg goes to sleep and it's just because you never",
        "statedSec": 900,
        "precision": "round",
        "bandMinSec": 720,
        "bandMaxSec": 1215
      },
      "action": "ignore"
    }
  ],
  "Friday Night Guided Meditation | Ajahn Brahmavamso | 24 February 2017 - 2019-01-23": [
    {
      "cue": {
        "island": 0,
        "atSec": 15.69,
        "endSec": 27.55,
        "text": "because you're going to be sitting for about half an hour, 25 minutes, so make sure your body is comfortable.",
        "statedSec": 1800,
        "precision": "round",
        "bandMinSec": 1440,
        "bandMaxSec": 2430
      },
      "action": "retain"
    }
  ],
  "Friday Night Guided Meditation | Ajahn Brahmavamso | 26-01-2018 - 2018-01-29": [
    {
      "cue": {
        "island": 0,
        "atSec": 110.95,
        "endSec": 134.81,
        "text": "so if you'd like to get yourself in a meditation posture, whichever that one that is, and on a chair is fine, on leaning against the wall is fine, just on the cushions, on the stools, where you can be",
        "statedSec": 1800,
        "precision": "round",
        "bandMinSec": 1440,
        "bandMaxSec": 2430
      },
      "action": "retain"
    }
  ],
  "Friday Night Guided Meditation | Ajahn Brahmavamso | 29-12-2017 - 2017-12-31": [
    {
      "cue": {
        "island": 0,
        "atSec": 0,
        "endSec": 6.03,
        "text": "excellent. so now we start with a guided meditation for half an hour.",
        "statedSec": 1800,
        "precision": "round",
        "bandMinSec": 1440,
        "bandMaxSec": 2430
      },
      "action": "retain"
    }
  ],
  "Friday Night Guided Meditation | Ajahn Brahmavamso | 3 March 2017 - 2019-01-30": [
    {
      "cue": {
        "island": 0,
        "atSec": 13.69,
        "endSec": 23.75,
        "text": "you're here, don't want to go anywhere else. just close your eyes and just be for half an hour instead of going or doing stuff.",
        "statedSec": 1800,
        "precision": "round",
        "bandMinSec": 1440,
        "bandMaxSec": 2430
      },
      "action": "retain"
    }
  ],
  "Friday Night Guided Meditation | Ajahn Brahmavamso | 30-11-2018 - 2018-12-03": [
    {
      "cue": {
        "island": 0,
        "atSec": 6.96,
        "endSec": 16.71,
        "text": "give me some time, half an hour to get an idea, some inspiration of what i'm going to talk about tonight.",
        "statedSec": 1800,
        "precision": "round",
        "bandMinSec": 1440,
        "bandMaxSec": 2430
      },
      "action": "retain"
    }
  ],
  "Friday Night Guided Meditation | Ajahn Brahmavamso | 5 January 2007 - 2019-03-07": [
    {
      "cue": {
        "island": 0,
        "atSec": 0,
        "endSec": 5.4,
        "text": "okay, so usually on a friday night we begin with 30 minutes of meditation.",
        "statedSec": 1800,
        "precision": "round",
        "bandMinSec": 1440,
        "bandMaxSec": 2430
      },
      "action": "retain"
    }
  ],
  "Friday Night Guided Meditation | Ajahn Brahmavamso | 7 April 2017 - 2019-02-20": [
    {
      "cue": {
        "island": 0,
        "atSec": 277.53,
        "endSec": 284.5,
        "text": "but a type of comfort you can maintain for 30 minutes.",
        "statedSec": 1800,
        "precision": "round",
        "bandMinSec": 1440,
        "bandMaxSec": 2430
      },
      "action": "retain"
    }
  ],
  "Friday Night Guided Meditation | Ajahn Brahmavamso | 8 December 2006 - 2019-02-28": [
    {
      "cue": {
        "island": 0,
        "atSec": 8.2,
        "endSec": 21.73,
        "text": "or we can just meditate for half an hour. and i think that if we meditate for an hour and a half, everyone will be left by the time i open my eyes.",
        "statedSec": 1800,
        "precision": "round",
        "bandMinSec": 1440,
        "bandMaxSec": 2430
      },
      "action": "retain"
    }
  ],
  "Friday Night Guided Meditation | Ajahn Brahmavamso | 9 December 2011 - 2019-06-27": [
    {
      "cue": {
        "island": 0,
        "atSec": 103.55,
        "endSec": 108.16,
        "text": "30 minutes set aside for your body and your mind.",
        "statedSec": 1800,
        "precision": "round",
        "bandMinSec": 1440,
        "bandMaxSec": 2430
      },
      "action": "retain"
    }
  ],
  "Friday Night Guided Meditation | Ajahn Brahmavamso | 9 February 2007 - 2019-03-21": [
    {
      "cue": {
        "island": 0,
        "atSec": 32.7,
        "endSec": 40.16,
        "text": "we're going to use this body for half an hour to sit still.",
        "statedSec": 1800,
        "precision": "round",
        "bandMinSec": 1440,
        "bandMaxSec": 2430
      },
      "action": "retain"
    }
  ],
  "Friday Night Guided Meditation | Ajahn Brahmavamso | 9 June 2006 - 2018-12-19": [
    {
      "cue": {
        "island": 0,
        "atSec": 55.63,
        "endSec": 60,
        "text": "so we're going to do about 30 minutes of guided meditation.",
        "statedSec": 1800,
        "precision": "round",
        "bandMinSec": 1440,
        "bandMaxSec": 2430
      },
      "action": "retain"
    }
  ],
  "Friday Night Guided Meditation | Ajahn Brahmavamso | 9 March 2007 - 2019-03-28": [
    {
      "cue": {
        "island": 0,
        "atSec": 181.03,
        "endSec": 199.27,
        "text": "so for this period of 30 minutes, we deliberately, carefully abandon all things which happened before in the past, never allowing the past to linger into the present moment.",
        "statedSec": 1800,
        "precision": "round",
        "bandMinSec": 1440,
        "bandMaxSec": 2430
      },
      "action": "retain"
    }
  ],
  "Friday Night Guided Meditation | Ajahn Brahmavamso | date unknown - 2018-10-25": [
    {
      "cue": {
        "island": 0,
        "atSec": 98.08,
        "endSec": 109.59,
        "text": "now it's like we turn the key and turn the engine off and take the key out and put it in our pockets for half an hour.",
        "statedSec": 1800,
        "precision": "round",
        "bandMinSec": 1440,
        "bandMaxSec": 2430
      },
      "action": "retain"
    }
  ],
  "Guided Meditation Meditation | Ajahn Brahmavamso | 23-06-2018 - 2018-06-25": [
    {
      "cue": {
        "island": 0,
        "atSec": 23.71,
        "endSec": 38.36,
        "text": "so that's for the introduction to meditation class here every saturday afternoon we do an ongoing class in that class we give about 15 minutes of instructions followed by about 45 minutes of meditatio",
        "statedSec": 900,
        "precision": "round",
        "bandMinSec": 720,
        "bandMaxSec": 1215
      },
      "action": "retain",
      "band": [
        2880,
        4860
      ]
    }
  ],
  "Guided Meditation | Ajahn Brahmavamso | 01-04-17 - 2017-04-02": [
    {
      "cue": {
        "island": 0,
        "atSec": 146.02,
        "endSec": 158.91,
        "text": "okay hopefully everybody knows what they're doing. and it's also if you're not used to sitting for 45 minutes, sometimes you disturb other people who are getting to the meditation.",
        "statedSec": 2700,
        "precision": "round",
        "bandMinSec": 2160,
        "bandMaxSec": 3645
      },
      "action": "retain"
    }
  ],
  "Guided Meditation | Ajahn Brahmavamso | 01-06-2013 - 2018-08-29": [
    {
      "cue": {
        "island": 0,
        "atSec": 762.34,
        "endSec": 775.31,
        "text": "we walk barefoot for an hour through the streets of perth and of course you get a bit cold but it doesn't really matter because after about 15 minutes you can't feel your feet anyway.",
        "statedSec": 3600,
        "precision": "round",
        "bandMinSec": 2880,
        "bandMaxSec": 4860
      },
      "action": "ignore"
    }
  ],
  "Guided Meditation | Ajahn Brahmavamso | 01-12-2012 - 2018-10-05": [
    {
      "cue": {
        "island": 0,
        "atSec": 442.83,
        "endSec": 454.39,
        "text": "imagine what that feels like. all those difficulties and problems in your life so far you can totally put it down, let it go and be free just for 40 minutes.",
        "statedSec": 2400,
        "precision": "round",
        "bandMinSec": 1920,
        "bandMaxSec": 3240
      },
      "action": "retain"
    }
  ]
};
